import DialogComponent from "components/Dialog";

import './themes/default.less';
import './index.less';

export default class NewPositionDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.defaultState = {
            currentPosition: 1,
            currentCategory: false,
            arrCreate: [],
            info: {},
            checkDiscount: false,
        };

        this.state = { ...this.defaultState };
    }

    title = "price.createNewPosition";

    show(info) {
        const { count, hidCb, currentCategory } = info;
        this.setState({ info, currentCategory });
        this.hidCb = hidCb;
        if (+count !== 1)
            this.dialogSaveLabel = "price.next";

        super.show();
    }

    onShow() {
    }

    addNewPos(arrCreate) {
        const { info, currentCategory, checkDiscount } = this.state;
        const { priceListId, startCode, categories } = info;

        const tempId = this._helper.number.generateUniqueID();

        const template = {
            domainId: 345,
            code: (arrCreate.length + startCode + 1) * 10,
            noDiscount: checkDiscount,
            priceListId: priceListId,
            linkId: 37,
            oldPriceCategoriesId: null,
            items: [],
            tempId: tempId,
            isGroup: false,
        };

        const cat = categories.find(it => it.tempId === currentCategory);

        if (cat) {
            delete cat.id;
            template.tempParentId = currentCategory;

        } else
            template.parentId = currentCategory;

        return [
            ...arrCreate,
            {
                ...template,
                altCode: this.inpCode.value,
                name: this.inpName.value,
                value: this.inpPrice.value,
            }
        ];

    }

    save() {
        const { info, currentPosition, arrCreate } = this.state;
        const { count } = info;

        if (!this.inpCode.value || !this.inpName.value || !this.inpPrice.value)
            return false;

        const newArrCreate = this.addNewPos(arrCreate);
        this.state.arrCreate = newArrCreate;

        if (+count === currentPosition) {
            this.hide();
            if (this.hidCb?.apply)
                this.hidCb(newArrCreate);

        } else if (+count === currentPosition + 1) {
            this.dialogSaveLabel = "main.save";
            this.changeState("currentPosition", currentPosition + 1);
        } else
            this.changeState("currentPosition", currentPosition + 1);

        this.inpCode.value = "";
        this.inpName.value = "";
        this.inpPrice.value = "";

    }

    renderContent() {
        const { info, currentPosition, currentCategory, checkDiscount } = this.state;
        const { count, categories } = info;

        return (
            <div className="newPositionDialog content flex col gap16">
                <div className="progress flex flex1 gap4">
                    {new Array(+count).fill("").map((it, i) => <div className={`itemProgres rad4 flex1 ${currentPosition > i ? "active" : ""}`} />)}
                </div>
                <div className="flex1">
                    {this.insertSelect({
                        value: currentCategory,
                        translate: true,
                        label: "price.section",
                        showLeftIcon: false,
                        items: categories.map(it => { it.id = it.id || it.tempId; return it; }),
                        onChange: this.changeState.bind(this, "currentCategory")
                    })}
                </div>
                <div className="flex1">
                    {this.insertInput({
                        ref: el => this.inpCode = el,
                        label: "price.positionCode",
                        placeHolder: "A00.00.000",
                    })}
                </div>
                <div className="flex1">
                    {this.insertTextarea({
                        ref: el => this.inpName = el,
                        label: "price.positionName",
                        placeHolder: "price.positionName",
                        onChange: null
                    })}
                </div>
                <div className="flex flex1 gap16">
                    <div className="flex1">
                        {this.insertSumInput({
                            ref: el => this.inpPrice = el,
                            label: "main.price",
                        })}
                    </div>
                    <div className="flex1" />
                </div>
                <div className="flex flex1 gap16">
                    {this.insertCheckBox({
                        checked: checkDiscount,
                        title: "price.positionNotQualify",
                        onClick: this.toggleState.bind(this, "checkDiscount")
                    })}
                </div>
            </div>
        );
    }
}
